import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class ProgramPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.programRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.programImport,
    );
    this.programAutocomplete = permissionChecker.match(
      Permissions.values.programAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.programCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.programEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.programDestroy,
    );
  }
}
